module.exports = __webpack_public_path__ + "img/77.0fa22f56.jpg";